import { Component } from '@angular/core';

@Component({
  selector: 'app-context-cancel-alert',
  templateUrl: './context-cancel-alert.component.html'
})
export class ContextCancelAlertComponent {}
